import { render, staticRenderFns } from "./AddCreditsConfirmation.vue?vue&type=template&id=146bfeea&scoped=true"
import script from "./AddCreditsConfirmation.vue?vue&type=script&lang=js"
export * from "./AddCreditsConfirmation.vue?vue&type=script&lang=js"
import style0 from "./AddCreditsConfirmation.vue?vue&type=style&index=0&id=146bfeea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146bfeea",
  null
  
)

export default component.exports